/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bell_medium'
export default icon
